// /* Action Types */
// export const USER_ACTION_TYPES = {
//   SET_CURRENT_USER: "SET_CURRENT_USER",
// }; Moved to user.types.js
import { USER_ACTION_TYPES } from "./user.types"

/* Initial State */
const INITIAL_STATE = {
  currentUser: null,
  isLoading: false,
  error: null,
};

/* Reducer Function */
export const UserReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ACTION_TYPES.SIGN_IN_SUCCESS:
      return {
        ...state,
        currentUser: payload,
      };

    case USER_ACTION_TYPES.SIGN_OUT_SUCCESS:
      return { ...state, currentUser: null };
    case USER_ACTION_TYPES.SIGN_OUT_FAILED:
    case USER_ACTION_TYPES.SIGN_IN_FAILURE:
    case USER_ACTION_TYPES.SIGN_UP_FAILURE:
      return { ...state, error: payload }

    default:
      return state; /* If no action is equal to the actions, 
                       then nothing is to be done by the reducer. 
                       So, we need to return the existing state 
                    */
  }
};
